module.exports = __webpack_public_path__ + "static/media/piloto2.473f98f6.png";